/** @format */

import * as actions from '../actions/gatewayProfile';

const defaultState = {
  isLoading: false,
  error: false,
};

export const gatewayProfile = (state = defaultState, action) => {
  switch (action.type) {
    case actions.FETCH_GATEWAY_PROFILE_REQUEST:
      return {
        isLoading: true,
        error: false,
      };
    case actions.FETCH_GATEWAY_PROFILE_SUCCESS:
      return {
        ...action.payload,
        isLoading: false,
        error: false,
      };
    case actions.FETCH_GATEWAY_PROFILE_FAILURE:
      return {
        ...action.payload,
        isLoading: false,
        error: true,
      };

    case actions.POST_GATEWAY_PROFILE_REQUEST:
      return {
        isLoading: true,
        error: false,
      };
    case actions.POST_GATEWAY_PROFILE_SUCCESS:
      return {
        ...action.payload,
        isLoading: false,
        error: false,
      };
    case actions.POST_GATEWAY_PROFILE_FAILURE:
      return {
        ...action.payload,
        isLoading: false,
        error: true,
      };

    case actions.DESTROY_GATEWAY_PROFILE_SUCCESS:
      return {
        isLoading: false,
        error: false,
      };

    default:
      return state;
  }
};
